import Badge, { badgeStyle } from '@/shared/v2/shared/components/Badge'
import Icon, { IconProps } from '@/shared/v2/shared/components/Icon'
import Tooltip from '@/shared/v2/shared/components/Tooltip'
import { VariantProps } from 'class-variance-authority'
import { isNil } from 'lodash'
import { TriangleAlert } from 'lucide-react'
import { ReactNode } from 'react'

type CautionBadgeProps = VariantProps<typeof badgeStyle> & {
    tooltip: string
    label?: ReactNode
}

const CautionBadge = ({ intent = 'warning', tooltip, label }: CautionBadgeProps) => {
    const intentToIconColor = (): IconProps['color'] => {
        switch (intent) {
            case 'negativeSecondary':
            case 'warningSecondary':
                return 'onColor'
            case 'default':
                return 'primary'
            default:
                return intent
        }
    }
    return (
        <Tooltip
            content={tooltip}
            trigger={
                <Badge intent={intent} data-testid={`__caution-badge-${intent}__`}>
                    <Icon
                        size="1"
                        icon={TriangleAlert}
                        color={intent === 'default' ? 'primary' : intentToIconColor()}
                    />
                    {!isNil(label) ? label : null}
                </Badge>
            }
        />
    )
}

export default CautionBadge
